import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CodepenSquareFilledSvg from "@ant-design/icons-svg/es/asn/CodepenSquareFilled";
import AntdIcon from "../components/AntdIcon";
var CodepenSquareFilled = function CodepenSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CodepenSquareFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CodepenSquareFilled.displayName = 'CodepenSquareFilled';
}
export default /*#__PURE__*/React.forwardRef(CodepenSquareFilled);